module.exports = __webpack_public_path__ + "static/media/job_novedia.0a873b2f.jpg";